import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../constants/routes';

export function setupCpoe(): void {
  applicationModuleRegistry.register({
    entry: 'cpoe',
    id: 'CPOE#9138',
    name: 'module.cpoe',
    route: ApplicationRoute.CPOE,
    routes: [
      {
        children: [
          {
            name: 'function.patient-encounter-details',
            route: ApplicationRoute.ENCOUNTER_PATIENT_DETAIL
          }
        ],
        main: true,
        name: 'function.list-of-patients',
        route: ApplicationRoute.PATIENT_LIST,
      },
    ]
  });
}
